Namespace 'Customer.Dashboard'

class Customer.Dashboard.TicketSummaryAuthorView extends Backbone.View
  template: JST['backbone/templates/customer/dashboard/summary/main/body/ticket_summary_author']
  className: 'summary-author'

  initialize: ({ticketSummary}) ->
    @ticketSummary = ticketSummary

  render: ->
    @$el.html @template
      name: @ticketSummary.authorName()
      username: @ticketSummary.authorUsername()
      nameColor: @_nameColor()
    @

  _nameColor: ->
    window.color_for(@ticketSummary.get('sub_type'))
